import { render, staticRenderFns } from "./DeleteEventModal.vue?vue&type=template&id=7f2d9825"
import script from "./DeleteEventModal.vue?vue&type=script&lang=js"
export * from "./DeleteEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports